// app/javascript/controllers/dropzone_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropzone", "fileInput", "fileList"];

  connect() {
    this.bindEvents();
  }

  bindEvents() {
    const events = ["dragenter", "dragover", "dragleave", "drop"];
    events.forEach(event => {
      this.dropzoneTarget.addEventListener(event, this.preventDefaults.bind(this), false);
    });

    this.dropzoneTarget.addEventListener("dragenter", this.highlight.bind(this), false);
    this.dropzoneTarget.addEventListener("dragover", this.highlight.bind(this), false);
    this.dropzoneTarget.addEventListener("dragleave", this.unhighlight.bind(this), false);
    this.dropzoneTarget.addEventListener("drop", this.unhighlight.bind(this), false);
    this.dropzoneTarget.addEventListener("drop", this.handleDrop.bind(this), false);

    this.fileInputTarget.addEventListener("change", this.updateFileList.bind(this), false);
  }

  preventDefaults(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  highlight() {
    this.dropzoneTarget.classList.add("border-indigo-500", "bg-indigo-50");
    this.dropzoneTarget.classList.remove("border-gray-300");
  }

  unhighlight() {
    this.dropzoneTarget.classList.remove("border-indigo-500", "bg-indigo-50");
    this.dropzoneTarget.classList.add("border-gray-300");
  }

  handleDrop(event) {
    const files = event.dataTransfer.files;
    this.fileInputTarget.files = files;
    this.updateFileList();
    const changeEvent = new Event("change", { bubbles: true });
    this.fileInputTarget.dispatchEvent(changeEvent);
  }

  updateFileList() {
    const files = this.fileInputTarget.files;
    if (files.length > 0) {
      this.fileListTarget.classList.remove("hidden");
      this.fileListTarget.innerHTML = "Selected files: ";
      const fileNames = Array.from(files).map(file => file.name);
      this.fileListTarget.innerHTML += fileNames.join(", ");
    } else {
      this.fileListTarget.classList.add("hidden");
    }
  }
}